import { FC, StatelessComponent } from 'react'
import { ENV } from 'constants/app'
import * as styles from 'components/features/pfm/SidebarGroups/SidebarGroups.styl'
import LoadingOverlay from 'components/atoms/preloaders/LoadingOverlay'
import PreferenceControls from 'components/features/preferences/Preferences'

export const SidebarGroups: FC<{}> = (props) => {
  const { children } = props
  const preferencePane = ENV !== 'prod' && ENV !== 'stage' && <PreferenceControls />

  return (
    <section className={ styles.container }>
      { preferencePane }
      { children }
    </section>
  )
}

export const SidebarGroupsPreloader: StatelessComponent = () => (
  <div className={ styles.container }>
    <div className={ styles.preloader }>
      <LoadingOverlay isTransparent />
    </div>
  </div>
)


export const SidebarGroupsTextSeparator: StatelessComponent = (props) => {
  const { children } = props

  return (
    <div className={ styles.textSeparator }>
      { children }
    </div>
  )
}

type SidebarGroupsCreateCustomItemProps = {
  onClick?: () => void
}
export const SidebarGroupsCreateCustomItem: StatelessComponent<SidebarGroupsCreateCustomItemProps> = (props) => {
  const { onClick, children } = props

  return (
    <a className={ styles.baseItem } onClick={ onClick }>
      <div className={ styles.addIconWrapper }>
        <i className={ styles.addIcon }>+</i>
      </div>
      <span className={ styles.linkText }>{ children }</span>
    </a>
  )
}
